import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';

type PostUploadRgParams = {
  deliverymanId: string;
  file: FormData;
  sideRg: 'RG_FRONT' | 'RG_BACK';
};

const postUploadRg = async ({
  deliverymanId,
  file,
  sideRg,
}: PostUploadRgParams) =>
  apiClient
    .post(
      `entregadores/${deliverymanId}/send-deliveryman-rg-picture-by-manager?rgTypeImage=${sideRg}`,
      file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then(response => {
      handleResponseSuccess(response, 'O RG foi enviado com sucesso!')();
    })
    .catch(
      handleResponseThrowError('Não foi possível enviar o RG do entregador.'),
    );

export const usePostUploadRg = ({
  onSettled,
}: { onSettled?: () => void; onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: postUploadRg,
    onSettled,
  });
};
